import { format } from "date-fns";
import { deleteToken, getToken } from "firebase/messaging";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { NOTIFICATION_OBJECT_TYPE } from "../../constants/status";
import { AuthService } from "../../features/auth/services/auth-service";
import { NotificationService } from "../../features/notification/services/notification-service";
import {
  getMessagingInstance,
  notificationManager,
  onMessageListener,
} from "../../firebase";
import { useFetchData } from "../../hooks/useFetch";
import { isSuccess } from "../../models/response/base-response";
import {
  NotificationResponse,
  PayloadFirebaseNotify,
} from "../../models/response/notification/notification";
import { MODULE_ROUTE } from "../../routers/module-router";
import { API_SETTINGS_ROUTER } from "../../services/api-config";
import { IRootState } from "../../store";
import { setCountNotify, setRefreshNotify } from "../../store/notifySlice";
import { toggleSidebar } from "../../store/themeConfigSlice";
import CookieUtils from "../../utils/cookie-utils";
import Dropdown from "../custom/drop-down";
import ImageCustom from "../custom/image-custom";
import IconBellBing from "../icons/icon-bell-bing";
import IconLogout from "../icons/icon-logout";
import IconMenu from "../icons/icon-menu";
// IconLaptop / IconMoon / IconSun: dùng cho nút chuyển theme đã tạm ẩn (xem bên dưới)
import IconUser from "../icons/icon-user";
import logo from "../icons/logo_laundry.png";
import ItemNotification from "../../features/notification/components/item-notification";
import CheckInButton from "./check-in-button";

type NavigableNotification = {
  // type union
  object_type: number;
  object_id: string;
};

// Cookie ghi lại push_token đã đăng ký, dạng "user_id|token" (1 trình duyệt chỉ có 1 token FCM dùng
// chung cho mọi tài khoản đăng nhập trên máy đó). CHỈ dùng để lấy lại token khi đăng xuất —
// KHÔNG dùng làm điều kiện bỏ qua đăng ký (xem `requestNotificationPermission`).
const PUSH_TOKEN_COOKIE = "tokenNotification";
const buildPushTokenKey = (token: string) =>
  `${CookieUtils.getCurrentUser().id ?? 0}|${token}`;
export const Header = () => {
    const navigate = useNavigate();
  const dispatch = useDispatch();
  const notificationButtonRef = useRef<HTMLButtonElement>(null);
  const notificationContainerRef = useRef<HTMLUListElement>(null);
  const { request: onDeviceTokens, baseResponse: resDeviceToken } =
    useFetchData.Post();
  const { fetch: onLogout } = AuthService.postLogout();
  const {
    fetch: onGetListNotification,
    response: responseNotification,
    loading: loadingNotification,
  } = NotificationService.getListNotification();
  const { fetch: onMakeAsRead, response: responseMakeAsRead } =
    NotificationService.makeAsRead();
  const { fetch: onMakeAsReadAll, response: responseMakeAsReadAll } =
    NotificationService.makeAsReadAll();
  const { fetch: onGetCountNotification, response: responseCountNotification } =
    NotificationService.getNotificationCountRead();
  const { total_unread, total_read, is_refresh_notify } = useSelector(
    (state: IRootState) => state.notify
  );
  const [selectedNotification, setSelectedNotification] =
    useState<NotificationResponse>(new NotificationResponse());

  const [listNotification, setListNotification] = useState<
    NotificationResponse[]
  >([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isShowListNotify, setIsShowListNotify] = useState(false);
  const [maxHeight, setMaxHeight] = useState(600);
  const [pushToken, setPushToken] = useState("");




  const isRtl =
    useSelector((state: IRootState) => state.themeConfig.rtlClass) === "rtl";

  const themeConfig = useSelector((state: IRootState) => state.themeConfig);

  const listenToPermissionChanges = () => {
    // Lắng nghe sự kiện thay đổi quyền thông báo
    if ("permissions" in navigator) {
      navigator.permissions
        .query({ name: "notifications" })
        .then((permissionStatus) => {
          // Lắng nghe thay đổi quyền
          permissionStatus.onchange = () => {
            if (permissionStatus.state === "granted") {
              // Người dùng vừa bật thông báo
              requestNotificationPermission();
            } else if (permissionStatus.state === "denied") {
              // Người dùng vừa tắt thông báo
              // Có thể hiển thị thông báo hướng dẫn bật lại
            }
          };
        })
        .catch((error) => {
          console.error("Lỗi khi kiểm tra quyền thông báo:", error);
        });
    }
  };

  const requestNotificationPermission = async () => {
    try {
      if (!("Notification" in window)) {
        console.warn("Trình duyệt không hỗ trợ Notification API.");
        return;
      }
      // Firebase Messaging khởi tạo bất đồng bộ + có thể bị tắt (môi trường dev / trình duyệt không hỗ trợ, VD
      // trang chạy HTTP) → không có thì bỏ qua, không xin quyền thông báo vô ích.
      const messaging = await getMessagingInstance();
      if (!messaging) return;
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        return;
      }
      const token = await getToken(messaging, {
        vapidKey: undefined,
        serviceWorkerRegistration: undefined,
      });
      // LUÔN đăng ký lại device mỗi lần app khởi động, KHÔNG cache-skip. Lý do: BE xoá bản ghi
      // device cũ mỗi lần đăng nhập (chính sách 1 tài khoản ↔ 1 thiết bị/platform), nên nếu FE thấy
      // "token này đăng ký rồi" mà bỏ qua thì trong DB không còn bản ghi nào ⇒ mất sạch thông báo.
      // register-device là upsert theo (user_id, push_token) nên gọi lại nhiều lần vô hại.
      if (token && isHaveToken()) {
        handleOnDeviceTokens(token);
        setPushToken(token);
      }
      return token;
    } catch (error) {
      console.error("Lỗi khi xin quyền thông báo hoặc lấy FCM token:", error);
    }
  };

  const isHaveToken = () => {
    const token = CookieUtils.getCurrentUser().access_token ?? "";
    if (token !== "") {
      return true;
    }
    return false;
  };

  const calculateMaxHeight = () => {
    if (notificationButtonRef.current) {
      const buttonRect = notificationButtonRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const headerHeight = buttonRect.bottom;
      const bottomPadding = 20; // Padding from bottom of screen
      const calculatedMaxHeight = viewportHeight - headerHeight - bottomPadding;

      // Set minimum height of 200px and maximum of 600px
      const finalMaxHeight = Math.max(200, Math.min(600, calculatedMaxHeight));
      setMaxHeight(finalMaxHeight);
    }
  };
  useEffect(() => {
    requestNotificationPermission();
    listenToPermissionChanges();

    document.addEventListener("visibilitychange", handleVisibilityChange);
    if (isHaveToken()) {
      onGetListNotification({ page: 1, limit: 20, status: -1 });
    }
    //clean
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      // Tab được focus lại, kiểm tra quyền thông báo
      if (
        "Notification" in window &&
        Notification.permission === "granted" &&
        !CookieUtils.getCookie("tokenNotification")
      ) {
        // Nếu có quyền nhưng chưa có token, yêu cầu lại
        requestNotificationPermission();
      }
    }
  };
  const handleOnDeviceTokens = (tokenNotification: string) => {
    if (tokenNotification !== "") {
      onDeviceTokens({
        endPoint: API_SETTINGS_ROUTER.API_REGISTER_DEVICE,
        data: {
          push_token: tokenNotification,
        },
      });
    }
  };
  useEffect(() => {
    notificationManager.setOnClickHandler((payload: PayloadFirebaseNotify) => {
      console.log("Notification clicked with payload:", payload);
    });
  }, []);
  onMessageListener()
    .then((payload: any) => {
      if (payload) {
        dispatch(setRefreshNotify({ is_refresh_notify: true }));
        dispatch(
          setCountNotify({
            total_read: total_read,
            total_unread: total_unread + 1,
          })
        );
      }
    })
    .catch((err) => {});

  useEffect(() => {
    if (!resDeviceToken) return;
    if (isSuccess(resDeviceToken)) {
      CookieUtils.setCookie(PUSH_TOKEN_COOKIE, buildPushTokenKey(pushToken));
    }
  }, [resDeviceToken]);

  /**
   * Push token FCM của trình duyệt này — ưu tiên lấy từ cache (cookie lưu dạng "user_id|token"),
   * nếu chưa có thì hỏi lại Firebase. Dùng để BE gỡ ĐÚNG thiết bị khi đăng xuất.
   */
  const resolveCurrentPushToken = async (): Promise<string> => {
    const cached = CookieUtils.getCookie<string>(PUSH_TOKEN_COOKIE);
    if (cached && cached.includes("|")) {
      return cached.slice(cached.indexOf("|") + 1);
    }
    try {
      const messaging = await getMessagingInstance();
      if (!messaging) return "";
      return (
        (await getToken(messaging, {
          vapidKey: undefined,
          serviceWorkerRegistration: undefined,
        })) ?? ""
      );
    } catch {
      return "";
    }
  };

  /**
   * Đăng xuất: phải GỠ liên kết trình duyệt ↔ tài khoản ở cả 3 nơi, nếu không tài khoản cũ
   * vẫn nhận push trên máy này (service worker chạy độc lập với phiên đăng nhập):
   *  1. BE  — /v1/auth/logout xoá bản ghi device (push_token) của user đang đăng nhập,
   *           phải gọi TRƯỚC khi xoá cookie user vì request cần Bearer token.
   *  2. FCM — deleteToken() huỷ token của trình duyệt này (lần sau sinh token mới).
   *  3. FE  — xoá cache "đã đăng ký device" để tài khoản đăng nhập kế tiếp đăng ký lại.
   */
  const handleLogout = async () => {
    try {
      await onLogout({ push_token: await resolveCurrentPushToken() });
    } catch (error) {
      console.error("Lỗi khi gọi API đăng xuất:", error);
    }
    try {
      const messaging = await getMessagingInstance();
      if (messaging) await deleteToken(messaging);
    } catch (error) {
      console.error("Lỗi khi huỷ token FCM:", error);
    }
    CookieUtils.eraseCookie(PUSH_TOKEN_COOKIE);
    CookieUtils.eraseCookie("user");
    window.location.href = MODULE_ROUTE.LOGIN;
  };

  useEffect(() => {
    if (!responseCountNotification) return;
    if (isSuccess(responseCountNotification)) {
      dispatch(setCountNotify(responseCountNotification.data));
    }
  }, [responseCountNotification]);
  useEffect(() => {
    if (isHaveToken()) {
      onGetCountNotification();
    }
    calculateMaxHeight();

    const handleResize = () => {
      calculateMaxHeight();
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", calculateMaxHeight);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", calculateMaxHeight);
    };
  }, []);

  const handleNotificationNavigation = (data: NavigableNotification) => {
    switch (data.object_type) {
      case NOTIFICATION_OBJECT_TYPE.ORDER:
        navigate(MODULE_ROUTE.ORDER, { state: { order_id: data.object_id } });
        break;
      default:
        break;
    }
  };

  const handleNotificationClick = (notification: NotificationResponse) => {
    setSelectedNotification(notification);
    if (notification.read_at === "") {
      onMakeAsRead(notification._id);
    }
    handleNotificationNavigation(notification);
  };

  useEffect(() => {
    notificationManager.setOnClickHandler((payload: PayloadFirebaseNotify) => {
      handleNotificationNavigation(payload);
    });
  }, []);

  useEffect(() => {
    navigator.serviceWorker?.addEventListener("message", (event) => {
      if (event.data?.type === "NOTIFICATION_CLICKED") {
        const payload = event.data.payload;
        handleNotificationNavigation(payload);
      }
    });
  }, []);
   useEffect(() => {
    if (!responseNotification) return;
    if (isSuccess(responseNotification)) {
      const newNotifications = responseNotification.data.list;

      if (currentPage === 1) {
        // First load
        setListNotification(newNotifications);
      } else {
        // Load more
        setListNotification((prev) => [...prev, ...newNotifications]);
      }

      // Check if there are more notifications to load
      setHasMore(newNotifications.length === 20); // Assuming 20 is the limit per page
      setIsLoadingMore(false);
    }
  }, [responseNotification, currentPage]);

  useEffect(() => {
    if (!responseMakeAsRead) return;
    if (isSuccess(responseMakeAsRead)) {
      setListNotification(
        listNotification.map((item) => {
          const time = format(new Date(), "dd/MM/yyyy HH:mm:ss");
          if (item._id === selectedNotification._id) {
            return { ...item, read_at: time };
          }
          return item;
        })
      );
    }
    dispatch(
      setCountNotify({
        total_read: total_read + 1,
        total_unread: total_unread - 1,
      })
    );
  }, [responseMakeAsRead]);

  useEffect(() => {
    if (!responseMakeAsReadAll) return;
    if (isSuccess(responseMakeAsReadAll)) {
      const time = format(new Date(), "dd/MM/yyyy HH:mm:ss");
      setListNotification(
        listNotification.map((item) => {
          return { ...item, read_at: time };
        })
      );
    }
    dispatch(
      setCountNotify({ total_read: total_read + total_unread, total_unread: 0 })
    );
  }, [responseMakeAsReadAll]);
  const handleNotificationScroll = (e: React.UIEvent<HTMLUListElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    // Check if scrolled to bottom (with 10px threshold)
    if (scrollHeight - scrollTop <= clientHeight + 10) {
      handleLoadMore();
    }
  };

  // Load more notifications
  const handleLoadMore = () => {
    if (!hasMore || isLoadingMore || loadingNotification) return;

    setIsLoadingMore(true);
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    if (isHaveToken()) {
      onGetListNotification({ page: nextPage, limit: 20, status: -1 });
    }
  };

  const refreshDataNotify = () => {
    setCurrentPage(1);
    setHasMore(true);
    setIsLoadingMore(false);
    dispatch(setRefreshNotify({ is_refresh_notify: false }));
    if (isHaveToken()) {
      onGetListNotification({ page: 1, limit: 20, status: -1 });
    }
  };
  return (
    <header
      className={`z-40 navbar${
        themeConfig.semidark && themeConfig.menu === "horizontal" ? "dark" : ""
      }`}
    >
      <div className="shadow-sm">
        <div className="relative bg-white flex w-full items-center px-5 py-2.5 dark:bg-black">
          <div className="flex items-center justify-between horizontal-logo lg:hidden ltr:mr-2 rtl:ml-2">
            <Link
              to="/"
              className="flex items-center main-logo shrink-0  max-[450px]:hidden"
            >
              <ImageCustom
                className="inline w-[120px] ltr:-ml-1 rtl:-mr-1"
                url={logo}
              />
            </Link>
            <button
              type="button"
              className="collapse-icon flex-none dark:text-[#d0d2d6] hover:text-primary dark:hover:text-primary flex lg:hidden ltr:ml-2 rtl:mr-2 p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:bg-white-light/90 dark:hover:bg-dark/60"
              onClick={() => {
                dispatch(toggleSidebar());
              }}
            >
              <IconMenu className="w-5 h-5" />
            </button>
          </div>

          <div className="sm:flex-1 ltr:sm:ml-0 ltr:ml-auto sm:rtl:mr-0 rtl:mr-auto flex items-center space-x-1.5 lg:space-x-2 rtl:space-x-reverse dark:text-[#d0d2d6]">
            <p className="flex-1 font-extrabold text-orange-600 uppercase">
              {/* {themeConfig.menuContent} */}
            </p>

            {/* Status group */}
            <div className="flex space-x-1.5 lg:space-x-2">
              {<CheckInButton />}
            </div>

            {/* Nút chuyển light/dark/system — tạm ẩn: dark mode mới chỉ style cho phần
                khung layout, các màn hình nghiệp vụ chưa có class `dark:`. App khóa ở
                light mode (xem layout.tsx + themeConfigSlice.tsx). Bật lại khi đã làm dark
                cho các feature page. */}
            {/* <div>
              {themeConfig.theme === "light" ? (
                <button
                  className={`${
                    themeConfig.theme === "light" &&
                    "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  }`}
                  onClick={() => {
                    dispatch(toggleTheme("dark"));
                  }}
                >
                  <IconSun />
                </button>
              ) : (
                ""
              )}
              {themeConfig.theme === "dark" && (
                <button
                  className={`${
                    themeConfig.theme === "dark" &&
                    "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  }`}
                  onClick={() => {
                    dispatch(toggleTheme("system"));
                  }}
                >
                  <IconMoon />
                </button>
              )}
              {themeConfig.theme === "system" && (
                <button
                  className={`${
                    themeConfig.theme === "system" &&
                    "flex items-center p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60"
                  }`}
                  onClick={() => {
                    dispatch(toggleTheme("light"));
                  }}
                >
                  <IconLaptop />
                </button>
              )}
            </div> */}

            <div className="dropdown shrink-0">
              <Dropdown
                offset={[0, 8]}
                placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                btnClassName="relative block p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:text-primary hover:bg-white-light/90 dark:hover:bg-dark/60 transition-all duration-300"
                setIsShowListNotify={setIsShowListNotify}
                button={
                  <span
                    ref={notificationButtonRef}
                    onClick={() => {
                      if (!isShowListNotify && is_refresh_notify) {
                        refreshDataNotify();
                      }
                      setIsShowListNotify(!isShowListNotify);
                    }}
                  >
                    <IconBellBing />
                    {total_unread > 0 && (
                      <span className="absolute items-center justify-center top-[-3px] flex  w-[18px] h-[18px] ltr:right-[-4px] rtl:left-0">
                        <span className="text-white items-center justify-center flex text-[9px] text-center w-[18px] h-[18px]  rounded-full bg-red-500">
                          {total_unread > 99 ? "99+" : total_unread}
                        </span>
                      </span>
                    )}
                  </span>
                }
              >
                <ul
                  ref={notificationContainerRef}
                  className="text-dark dark:text-white-dark !py-0 w-[368px] overflow-y-auto dark:text-white-light/90 min-h-[100px]"
                  style={{ maxHeight: `${maxHeight}px` }}
                  onScroll={handleNotificationScroll}
                >
                  <li
                    className="sticky top-0 z-10 bg-white dark:bg-black"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex items-center justify-between px-4 py-2 border-b">
                      <div className="text-lg font-semibold">Thông báo</div>
                      <p
                        className="cursor-pointer hover:underline hover:text-primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          onMakeAsReadAll();
                        }}
                      >
                        Đánh dấu tất cả đã đọc
                      </p>
                    </div>
                  </li>

                  {listNotification.map((notification) => (
                    <ItemNotification
                      key={notification._id}
                      notification={notification}
                      handleClick={() => handleNotificationClick(notification)}
                    />
                  ))}

                  {/* Loading more indicator */}
                  {isLoadingMore && (
                    <li className="px-4 py-3 text-center">
                      <div className="flex items-center justify-center space-x-2">
                        <div className="w-4 h-4 border-b-2 rounded-full animate-spin border-primary"></div>
                        <span className="text-sm text-gray-500">
                          Đang tải thêm...
                        </span>
                      </div>
                    </li>
                  )}

                  {/* Empty state */}
                  {listNotification.length === 0 && !loadingNotification && (
                    <li className="px-4 py-8 text-center">
                      <span className="text-sm text-gray-500">
                        Không có thông báo nào
                      </span>
                    </li>
                  )}
                </ul>
              </Dropdown>
            </div>

            <div className="flex dropdown shrink-0">
              <Dropdown
                offset={[0, 8]}
                placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                btnClassName="relative group block"
                button={
                  <ImageCustom
                    className="object-cover rounded-full w-9 h-9 saturate-50 group-hover:saturate-100 border border-[#f2f2f2]"
                    isLocal={false}
                    url={CookieUtils.getCurrentUser().avatar ?? ""}
                  />
                }
              >
                <ul className="text-dark dark:text-white-dark !py-0 w-[230px] font-semibold dark:text-white-light/90">
                  <li>
                    <div className="flex items-center px-4 py-4">
                      <ImageCustom
                        className="object-cover w-10 h-10 rounded-full border border-[#f2f2f2]"
                        isLocal={false}
                        url={CookieUtils.getCurrentUser().avatar ?? ""}
                      />
                      <div className="truncate ltr:pl-4 rtl:pr-4">
                        <h4 className="text-base">
                          {CookieUtils.getCurrentUser().name ?? ""}
                        </h4>
                      </div>
                    </div>
                  </li>
                  <li>
                    <Link
                      to={MODULE_ROUTE.PROFILE}
                      className="text-gray-600 dark:hover:text-white"
                    >
                      <IconUser className="w-4.5 h-4.5 ltr:mr-2 rtl:ml-2 shrink-0" />
                      Tài khoản của tôi
                    </Link>
                  </li>
                  <li className="border-t border-white-light dark:border-white-light/10">
                    <a
                      href="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleLogout();
                      }}
                      className="text-danger !py-3"
                    >
                      <IconLogout className="w-4.5 h-4.5 ltr:mr-2 rtl:ml-2 rotate-90 shrink-0" />
                      Đăng xuất
                    </a>
                  </li>
                </ul>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
